import { Component, OnInit } from "@angular/core";

import { SessionService } from "./../../common/services/session.service";
import { UtilityService } from "./../../shared/utility.service";

@Component({
  selector: "app-display-office-name",
  templateUrl: "./display-office-name.component.html",
  styleUrls: ["./display-office-name.component.scss"],
})
export class DisplayOfficeNameComponent implements OnInit {
  officeData: any;
  userInfo: any;
  show: boolean = true;
  constructor(private ss: SessionService, private us: UtilityService) {}

  openVirtualViewAll() {
    this.us.setAllVirtualView();
  }

  private showElement() {
    if (this.officeData === undefined || this.officeData === null) {
      this.show = false;
    } else if (
      this.userInfo &&
      this.userInfo.role === "VIEWER" &&
      !this.ss.isVirtualView()
    ) {
      this.show = false;
    } else if (
      this.ss.isVirtualView() &&
      this.ss.getSessionVirtualViewId() &&
      this.ss.getSessionVirtualViewId().id === "ALL"
    ) {
      this.show = false;
    }
  }

  ngOnInit() {
    this.officeData = this.ss.getOffice();
    this.userInfo = this.ss.getUserInfo();
    this.showElement();
  }
}
